<template>
	<div
		:id="id"
		class="default-icon-list"
		:class="{ 'default-icon-list--card': isCard }"
	>
		<h2 v-if="title" class="default-icon-list__title">
			{{ title }}
		</h2>
		<slot>
			<template v-for="i in icons" :key="i.id">
				<DefaultIcon v-if="i.fields" :fields="i.fields"></DefaultIcon>
			</template>
		</slot>
	</div>
</template>
<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const title = computed(() => props.fields?.title?.value);
const icons = computed(() => props.fields?.icons);
const isCard = computed(() => props.fields?.isCard?.value);
const id = computed(() => props.fields?.id?.value);
</script>

<style lang="scss">
.default-icon-list {
	gap: var(--spacing-2, 16px);
	border-radius: var(--Border-Radius-md, 16px);
	display: grid;
	padding: 0;
	margin: 0 var(--spacing-2, 16px) var(--spacing-10, 80px);
	background: transparent;

	.default-icon {
		flex-direction: row;
		gap: var(--spacing-2, 16px);

		&:not(:last-child) {
			border-bottom: 1px solid rgba(242, 231, 187, 0.25);
			padding-bottom: var(--spacing-2, 16px);
		}
	}

	.default-icon-list__title {
		color: var(--color-white, #fff);
		font-family: var(--primary-font, sans-serif);
		font-size: var(--text-lg, 20px);
		font-weight: 900;
		line-height: 110%;
		text-transform: uppercase;
		margin-bottom: 20px;
	}

	&.default-icon-list--card {
		padding: var(--spacing-2, 16px);
		background: var(--Neutrals-grey-7, #282828);

		.default-icon {
			border-bottom: none;
			padding-bottom: 0;
		}

		.default-icon__label,
		.default-icon__description {
			color: var(--Neutrals-grey-1, #e9e9e9);
			font-family: var(--primary-font, sans-serif);
			font-size: 14px;
			font-weight: 400;
			line-height: 150%;
		}
	}
}
</style>
